import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';
import logo from '../Assets/Images/privateIQ2.svg';

const Navbar = () => {
    const [isOpen, setIsOpen] = useState(false); // State to control the menu toggle
    const location = useLocation(); // Get current route

    const toggleMenu = () => {
        setIsOpen(!isOpen); // Toggle the menu open/close
    };

    // Define landing pages
    const isLandingPage = ['/','/home', '/login', '/register'].includes(location.pathname);

    // Define pages where the navbar links should not be shown
    const hiddenPages = ['/contact', '/termsofservice', '/privacypolicy', '/profile-setup', '/checkout'];
    const showNavLinks = !hiddenPages.includes(location.pathname);

    return (
        <nav className="navbar">
            <div className="navbar-logo">
                <Link to={isLandingPage ? '/home' : '/feestable'}>
                    <img src={logo} alt="PrivateIQ Logo" className="logo-image" />
                </Link>
            </div>

            {showNavLinks && (
                <>
                    <div className="navbar-toggle" onClick={toggleMenu}>
                        ☰ {/* Hamburger icon */}
                    </div>
                    <ul className={`navbar-links ${isOpen ? 'show' : ''}`}>
                        {isLandingPage ? (
                            <>
                                <li>
                                    <Link to="/register" onClick={() => setIsOpen(false)}>
                                        Register
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact" onClick={() => setIsOpen(false)}>
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/login" onClick={() => setIsOpen(false)}>
                                        Login
                                    </Link>
                                </li>
                            </>
                        ) : (
                            <>
                                <li>
                                    <Link to="/contact" onClick={() => setIsOpen(false)}>
                                        Contact
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/logout">Logout</Link>
                                </li>
                            </>
                        )}
                    </ul>
                </>
            )}
        </nav>
    );
};

export default Navbar;
